import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardBody, CardHeader } from 'reactstrap';
import { Handling, Terminal } from '../types/graph';
import { useTeusCount } from '../hooks';
import { DeepPartialOverride, GraphDeepPartialNotListed } from '../types';
import numeral from "numeral";

type TeusCardProps = Pick<DeepPartialOverride<Terminal, { teusLimit?: number, handlings?: GraphDeepPartialNotListed<Handling, 'type' | 'checkedIn' | 'checkedOut' | 'loadingUnitSizeFromGate' | 'loadingUnitSize'>[] }>, 'teusLimit' | 'handlings'>;

const TerminalTeusCard = (props: TeusCardProps) => {

    const { t } = useTranslation('common');
    const { current, expected, remaining } = useTeusCount(props);

    return <Card>
        <CardHeader>
            <h4>{t('terminal.home.teus.title')}</h4>
        </CardHeader>
        <CardBody>
            <dl>
                <dt>{t('terminal.home.teus.current')}</dt>
                <dd>{numeral(current).format('0[.]0')}</dd>
                <dt>{t('terminal.home.teus.expected')}</dt>
                <dd>{numeral(expected).format('0[.]0')}</dd>
                <dt>{t('terminal.home.teus.remaining')}</dt>
                <dd>{numeral(remaining).format('0[.]0')}</dd>
            </dl>
        </CardBody>
    </Card>
};


export default TerminalTeusCard;